/**
 * Google's Places `.pac-container` dropdown is appended to <body> by the Maps
 * JS SDK and has no built-in "hide when empty" behavior of its own — this
 * app's code was manually forcing it visible on every input focus, even when
 * it had no predictions yet (e.g. right after picking a location and
 * refocusing the field), producing a blank dropdown box.
 *
 * Call this once, immediately after constructing
 * `new google.maps.places.Autocomplete(...)`. It binds a MutationObserver to
 * that instance's specific `.pac-container` so it's only ever visible while
 * it actually contains suggestion items — no separate show/hide-on-focus
 * wiring needed.
 */
export function syncPacContainerVisibility(): void {
  const panel = Array.from(document.querySelectorAll<HTMLElement>('.pac-container')).pop();
  if (!panel || panel.dataset['visibilitySynced']) return;
  panel.dataset['visibilitySynced'] = 'true';
  panel.style.display = 'none';

  const observer = new MutationObserver(() => {
    panel.style.display = panel.querySelector('.pac-item') ? '' : 'none';
  });
  observer.observe(panel, { childList: true, subtree: true });
}
